export const SET_DARK_MODE = "SET_DARK_MODE";
export const SET_PASSPORT_INFO = "SET_PASSPORT_INFO";
export const SET_IS_SHOW_BTN = "SET_IS_SHOW_BTN";
export const SET_LOADING = "SET_LOADING";
export const SET_MONEY_CATEGORIES = "SET_MONEY_CATEGORIES";
